import { Link, useNavigate } from "react-router-dom";
import { ELITELINKS } from "../../app-routes/links";
import { useEffect } from "react";
import {
  // getUser,
  LINKEDIN_CLIENT_ID,
  LINKEDIN_REDIRECT_URI,
} from "../../api-services/process";
import Preloader from "../../app-components/preloader/Preloader";
import { errorAlert, successAlert } from "../../app-util/SweetAlert";
import apiClient from "../../api-services/ApiClient";
import { useState } from "react";
import { HoneConnectLogo } from "../../assets/img";
import {
  Slider1,
  Slider2,
  Slider3,
  Slider4,
  Slider5,
} from "../../assets/img/elite";
import { inputStyle } from "../../app-util/helpers";
import { UserProfileInterface } from "../../app-schemas/user.interface";
import AuthLayout from "../../app-layouts/AuthLayout";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const WelcomeElite = () => {
  sessionStorage.removeItem("linkedinCallbackCalled");
  const navigate = useNavigate();
  // const user: UserProfileInterface = getUser();
  const [laoding, setLoading] = useState(false);
  const [user, setUser] = useState<Partial<UserProfileInterface>>({});

  const [formData, setFormData] = useState({
    linkedinLink: "",
    referralCode: "",
  });

  const handleFormState = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    const checkEliteStatus = async () => {
      try {
        setLoading(true);
        const sub_res: any = await apiClient.get(
          `get-active-elite-subscription`,
        );
        const user_res = await apiClient.get(`user-info`);

        setUser(user_res.data);

        console.log(user_res.data);

        if (!user_res.data?.username || !user_res.data?.DOB) {
          navigate(ELITELINKS.REGISTER_STEP_TWO);
          return;
        }

        if (
          user_res.data.elite_status === "ACTIVE" &&
          sub_res.data.status === "ACTIVE"
        ) {
          navigate(ELITELINKS.HOME);
        }
        if (
          user_res.data.elite_status === "ACTIVE" &&
          sub_res.data.status !== "ACTIVE"
        ) {
          navigate(ELITELINKS.SUBSCRIPTIONS);
        }
      } catch (error) {
        console.error("Subscription check failed:", error);
        navigate(ELITELINKS.SUBSCRIPTIONS);
      } finally {
        setLoading(false);
      }
    };

    checkEliteStatus();
    // eslint-disable-next-line
  }, []);

  const handleLinkedIn = () => {
    setLoading(true);

    const params = new URLSearchParams({
      response_type: "code",
      client_id: LINKEDIN_CLIENT_ID,
      redirect_uri: LINKEDIN_REDIRECT_URI,
      scope: "openid profile email",
      state: crypto.randomUUID(),
    });

    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
  };

  useEffect(() => {
    const isLinkedInSet = localStorage.getItem("IsRequestedElite");
    if (isLinkedInSet) {
      // setOnboardingState(4);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get("success");

    if (success || user.linkedin_email) {
      setLoading(false);
      // setOnboardingState(3);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const referralCodeValidation = async () => {
    if (formData.referralCode) {
      // verify code;
      try {
        setLoading(true);
        await apiClient.post("/verify-referrral-code", {
          referralCode: formData.referralCode,
        });
        successAlert("successfully");
        navigate(ELITELINKS.SUBSCRIPTIONS);
      } catch (error) {
        console.error("Error", error);
        errorAlert(JSON.stringify(error));
      } finally {
        setLoading(false);
      }
    } else {
      errorAlert("referral code is required");
    }
  };

  if (laoding) {
    return (
      <AuthLayout title="Home">
        <Preloader loading={true} />
      </AuthLayout>
    );
  }

  return (
    <>
      {user.elite_status === "APPROVED" ? (
        <div className="lg:col-span-3 bg-white shadow relative h-[100vh]">
          <div className="bg-white w-full">
            <div className="text-sm font-semibold flex justify-between px-4 pt-14">
              <Link
                to="#!"
                className="text-honeConnectPurple flex items-center justify-center text-center w-full"
              >
                <img
                  src={HoneConnectLogo}
                  alt="HoneConnect"
                  className="h-[35px]"
                />
              </Link>
            </div>

            {/* <!-- page lead text --> */}
            <div className="px-5 py-12">
              <h4 className="text-[2.5rem] text-honeConnectBlack font-medium mb-2.5 text-honeConnectPurple leading-[35px] text-center">
                Welcome!
              </h4>
            </div>
          </div>

          <div className="relative top-[-10px] w-full pt-4 lg:pt-20 pb-0 px-5 lg:px-10 lg:px-28 text-gray-500 bg-white rounded-t-lg">
            <div className="flex flex-col text-sm font-medium mb-6 text-gray-500">
              <label htmlFor="referralCode" className="mb-1">
                Access Code
              </label>
              <input
                onChange={handleFormState}
                className={`${inputStyle} bg-transparent border-gray-200 text-black rounded-[0px] outline-none focus:outline-none font-medium text-[12px] shadow-sm hover:shadow`}
                placeholder="Enter your access code"
                name="referralCode"
                autoComplete="off"
                value={formData.referralCode}
                type="text"
              />
              <span className="text-red-600 text-[10px]"></span>
            </div>

            <div className="flex justify-center text-xs mt-2 mb-10 gap-1 items-end">
              <button
                onClick={() => {
                  referralCodeValidation();
                }}
                className="bg-honeConnectPurple text-white text-sm w-full p-3 py-4 border-0 mt-2 hover:shadow-2xl rounded-lg  shadow-sm hover:shadow"
              >
                <span>Continue</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          allowTouchMove={true}
          autoplay={true ? { delay: 35000 } : false}
          pagination={{
            clickable: true,
            bulletClass:
              "swiper-pagination-bullet !bg-gray-300 block h-[5px] w-[40px] rounded-[20px]",
            bulletActiveClass:
              "!bg-honeConnectPurple block h-[5px] w-[20px] rounded-[20px]",
          }}
          className="w-full h-screen"
        >
          {/* Slide 1 — Your Content */}
          <SwiperSlide className="h-full flex items-center justify-center">
            {!user.linkedin_email ? (
              <>
                <div className="text-sm font-semibold flex justify-between px-4 pt-14 w-full">
                  <Link to="#!" className="flex">
                    <img
                      src={HoneConnectLogo}
                      alt="HoneConnect"
                      className="h-[35px]"
                    />
                  </Link>
                </div>

                <div className="bg-white py-5 p-2 w-full rounded-2xl text-gray-500 mt-6">
                  <p className="text-lg px-3 mb-8 font-medium">
                    You're one step away
                  </p>

                  <p className="text-sm px-3">
                    Kindly click the button below to complete your registration.
                  </p>
                </div>
                <div className="flex-col justify-center text-xs mb-5 gap-1 items-center fixed w-full p-5 left-0 right-0 bottom-16">
                  <button
                    onClick={() => {
                      handleLinkedIn();
                    }}
                    className="disabled:bg-gray-600 bg-[#6c219a] text-honeConnectOrange text-sm w-full p-3 py-4 border-0 mt-2 hover:shadow-2xl rounded-lg"
                  >
                    <span>Become a Member</span>
                  </button>
                </div>
              </>
            ) : (
              <div className="flex flex-col justify-center w-full h-full px-1 animate-slow-fade-in">
                <div className="text-sm font-semibold flex justify-between px-4 pt-14 w-full">
                  <Link to="#!" className="flex">
                    <img
                      src={HoneConnectLogo}
                      alt="HoneConnect"
                      className="h-[35px]"
                    />
                  </Link>
                </div>

                <div className="bg-white py-5 p-2 w-full rounded-2xl text-gray-500 mt-6">
                  <p className="text-lg px-3 mb-8 font-medium">
                    Great! Your application has been successfully submitted!
                  </p>

                  <p className="text-sm px-3">
                    We're thrilled that you're interested in becoming an Elite
                    Member. Our team will review your eligibility and we'll get
                    back to you as soon as we can.
                  </p>

                  <p className="text-sm px-3 mt-5">
                    Applicants who are approved will receive an access code by
                    email
                  </p>
                </div>
              </div>
            )}
          </SwiperSlide>

          {/* Slide 2 — Image Placeholder */}
          <SwiperSlide>
            <div className="flex items-center justify-center h-full bg-red-200">
              <img
                src={Slider1}
                alt="slider-1"
                className="w-full h-screen object-cover"
              />
            </div>
          </SwiperSlide>

          {/* Slide 3 — Image Placeholder */}
          <SwiperSlide>
            <div className="flex items-center justify-center h-full bg-gray-700">
              <img
                src={Slider2}
                alt="slider-1"
                className="w-full h-screen object-cover"
              />
            </div>
          </SwiperSlide>

          {/* Slide 4 — Image Placeholder */}
          <SwiperSlide>
            <div className="flex items-center justify-center h-full bg-blue-200">
              <img
                src={Slider3}
                alt="slider-1"
                className="w-full h-screen object-cover"
              />
            </div>
          </SwiperSlide>

          {/* Slide 5 — Image Placeholder */}
          <SwiperSlide>
            <div className="flex items-center justify-center h-full bg-blue-200">
              <img
                src={Slider4}
                alt="slider-1"
                className="w-full h-screen object-cover"
              />
            </div>
          </SwiperSlide>

          {/* Slide 6 — Image Placeholder */}
          <SwiperSlide>
            <div className="flex items-center justify-center h-full bg-blue-200">
              <img
                src={Slider5}
                alt="slider-1"
                className="w-full h-screen object-cover"
              />
            </div>
          </SwiperSlide>
        </Swiper>
      )}

      <Preloader loading={laoding} />
    </>
  );
};

export default WelcomeElite;
